
let token;

function setUtilsToken(t) {
  token = t;
}

async function sendPost(token, url, payload) {
  const headers = {
    "Content-Type": "application/json"
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const r = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: headers
  });
  console.log(r);
  if (r.ok) {
    if (r.status === 200) {
      const data = await r.json();
      return data;  
    }
  }
  else {
    throw {
      status: r.status
    }
  }
}

async function sendGetRequest(url) {
  try {
    const r = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!r.ok) {
      if (r.status === 403) {
        throw {
          status: 403,
          statusText: 'Forbidden'
        }
      }
      let d;
      try {
        d = await r.json();
      }
      catch (e2) {
        d = await r.text();
      }
      throw {
        data: d,
        status: r.status
      }
    }
    const data = await r.json();
    return data;
  }
  catch (e) {
    console.log(e);
    throw e;
  }
}

async function sendPut(url, payload) {
  const headers = {
    "Content-Type": "application/json"
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const r = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(payload),
    headers: headers
  });
  console.log(r);
  if (r.ok) {
    if (r.status === 200) {
      const data = await r.json();
      return data;  
    }
  }
  else {
    throw {
      status: r.status
    }
  }
}

function renderRoles(roles) {
  let output = '';
  roles.forEach(r => {
    if (output) {
      output += ',';
    }
    output += r.role.label
  });
  return output
}

export {
  setUtilsToken,
  sendPost,
  sendGetRequest,
  sendPut,
  renderRoles
}